// 訂閱方案限制配置
export const SUBSCRIPTION_LIMITS = {
  free: {
    name: '免費試用',
    maxAccounts: 0,
    postsPerDay: 0,
    maxPublishTimes: 0,
    maxTemplates: 0,
    features: []
  },
  basic: {
    name: 'AI 基礎版',
    maxAccounts: 999, // 無限制，以購買數量為準
    postsPerDay: 1,   // 每天1篇
    maxPublishTimes: 1, // 只能設定1個發文時段
    maxPostsPerWeek: 7,  // 每週最多7篇
    maxTemplates: 1,    // 固定模板
    features: [
      '每週最多 7 篇自動發文',
      '固定模板 + 固定語氣',
      '基礎圖卡生成',
      '排程發佈功能',
      '基礎數據分析'
    ]
  },
  professional: {
    name: 'AI 專業版',
    maxAccounts: 999,
    postsPerDay: 3,      // 每天3篇
    maxPublishTimes: 3,  // 最多3個發文時段
    maxPostsPerWeek: 20,  // 每週最多20篇
    maxTemplates: 3,     // 多模板自由切換
    features: [
      '每週最多 20 篇自動發文',
      '多模板自由切換',
      '自動生成含 CTA 文案',
      '日常經營 + 特殊目的貼文',
      '進階數據分析',
      '多平台同步'
    ]
  },
  brand: {
    name: 'AI 品牌版',
    maxAccounts: 999,
    postsPerDay: 5,
    maxPublishTimes: 5,
    maxPostsPerWeek: 35,  // 每週最多35篇
    maxTemplates: 99,
    features: [
      '每週最多 35 篇自動發文',
      '無限模板',
      '品牌治理與標準化',
      '完整數據分析',
      '優先支援'
    ]
  }
};

/**
 * 獲取訂閱方案的限制
 * @param {string} planType - 方案類型: 'free', 'basic', 'professional', 'brand'
 * @returns {object} 方案限制配置
 */
export function getSubscriptionLimits(planType) {
  return SUBSCRIPTION_LIMITS[planType] || SUBSCRIPTION_LIMITS.free;
}

/**
 * 檢查是否可以添加更多發文時段
 * @param {string} planType - 方案類型
 * @param {number} currentTimeSlots - 目前已設定的時段數
 * @returns {boolean}
 */
export function canAddMorePublishTimes(planType, currentTimeSlots) {
  const limits = getSubscriptionLimits(planType);
  return currentTimeSlots < limits.maxPublishTimes;
}

/**
 * 獲取可用的發文時段數量
 * @param {string} planType - 方案類型
 * @returns {number}
 */
export function getAvailablePublishTimes(planType) {
  const limits = getSubscriptionLimits(planType);
  return limits.maxPublishTimes;
}

export default {
  SUBSCRIPTION_LIMITS,
  getSubscriptionLimits,
  canAddMorePublishTimes,
  getAvailablePublishTimes
};
